
import { defineComponent } from 'vue';
import { themeChange } from 'theme-change'

export default defineComponent({
  name: 'DarkModeSelector',
  props: {
    size: {
      type: [Number, String],
      default: 5,
      required: false
    }
  },
  data: () => ({
    darkMode: false,
    key: ''
  }),
  watch: {
    darkMode(val) {
      if (val) {
        document?.querySelector('html')?.setAttribute('data-theme', 'dark')
        document?.querySelector('html')?.setAttribute('class', 'dark')
        localStorage.setItem('theme', 'dark')
      }
      else {
        document?.querySelector('html')?.setAttribute('data-theme', 'light')
        document?.querySelector('html')?.setAttribute('class', 'light')
        localStorage.setItem('theme', 'light')
      }
    }
  },
  async mounted() {
    themeChange(false)
    await this.getTheme()
  },
  methods: {
    getTheme() {
      this.key = localStorage.getItem('theme') || 'dark'
      this.darkMode = this.key === 'dark' ? true : false
      return this.key
    },
  },
})
